import React from 'react'
import Loader from '../loader/loader'

export const PositionsTableToggle = (
  {
    onPositionsRequest,
    isOpen,
    setIsOpen,
    isLoading
  }) => {

  const onShowPositions = () => {
    setIsOpen(!isOpen)
    if(!isOpen) {
      onPositionsRequest()
    }
  }

  return (
    <div className={`bg-[#FFFFFF] py-[1.6rem] transition hover:bg-[#E1CCE7] hover:cursor-pointer flex gap-[3rem] justify-center mt-[8px] text-Regular(14_16) font-bold text-Accent/Blue`}
      onClick={onShowPositions}>
      <div className={`flex gap-[1.2rem]`}>
        <span>{isOpen ? 'Скрыть позции' : 'Показать позиции'}</span>
        <i className={`${isOpen ? 'rotate-180' : ''} icon-arrow 
        text-Regular(12_14) duration-300 ease-in-out m-auto  flex items-center justify-center`}>
        </i>
      </div>
      {isLoading && <div className={`relative`}><Loader/></div>}
    </div>
  )
}
